import React, { useState, useEffect } from "react";
import axios from "axios";
import "./detailsPacks.css"; // Fichier renommé

const Popup_detailsPacks = ({ packName, userId, onClose }) => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [originalPaymentDate, setOriginalPaymentDate] = useState(null);
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const formatPrice = (price) => {
    if (price === null || price === undefined) {
      return "0.000";
    }
    return Number(price).toFixed(3);
  };

  const isValidDate = (date) => date instanceof Date && !isNaN(date.getTime());

  // Calculate the current period and progress
  const calculatePeriodAndProgress = () => {
    if (!originalPaymentDate) {
      return { progress: 0, currentStartDate: null, currentEndDate: null };
    }

    const now = new Date();
    const startDate = new Date(originalPaymentDate);
    const periodDuration = 31 * 24 * 60 * 60 * 1000; // 31 days in milliseconds

    // Calculate how many full periods have passed
    const elapsedTime = now - startDate;
    const periodsPassed = Math.floor(elapsedTime / periodDuration);

    // Calculate the start and end dates of the current period
    const currentStartDate = new Date(startDate.getTime() + periodsPassed * periodDuration);
    const currentEndDate = new Date(currentStartDate.getTime() + periodDuration);

    // Calculate progress within the current period
    let progress = 0;
    if (now >= currentStartDate && now <= currentEndDate) {
      const totalDuration = currentEndDate - currentStartDate;
      const elapsedDuration = now - currentStartDate;
      progress = (elapsedDuration / totalDuration) * 100;
    } else if (now > currentEndDate) {
      progress = 100; // Show full progress if the current period is complete
    }

    console.log(`Frontend - calculatePeriodAndProgress - currentStartDate: ${currentStartDate.toISOString()}`);
    console.log(`Frontend - calculatePeriodAndProgress - currentEndDate: ${currentEndDate.toISOString()}`);
    console.log(`Frontend - calculatePeriodAndProgress - now: ${now.toISOString()}`);
    console.log(`Frontend - calculatePeriodAndProgress - Progress: ${progress}%`);

    return {
      progress: Math.min(Math.max(progress, 0), 100),
      currentStartDate,
      currentEndDate,
    };
  };

  // Fetch pack details
const fetchPackDetails = async () => {
    if (!packName || !userId) {
      setError("Pack name or User ID is missing.");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(
        `${API_URL}/payments/details-by-pack/${encodeURIComponent(packName)}/${userId}`
      );
      const { hasPaid, totalPoints, totalValue, originalPaymentDate: originalDateStr, withdrawalDays } = response.data;

      if (!hasPaid) {
        setError("No approved payment found for this pack.");
        setLoading(false);
        return;
      }

      const originalDate = new Date(originalDateStr);
      if (!isValidDate(originalDate)) {
        throw new Error("Invalid original payment date received from the API");
      }

      setOriginalPaymentDate(originalDate);
      setDetails({
        monthlyBonus: {
          points: totalPoints,
          value: totalValue,
        },
        withdrawalDays,
      });
    } catch (error) {
      setError("Failed to fetch pack details. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // Load data when packName or userId changes
  useEffect(() => {
    fetchPackDetails();
  }, [packName, userId]);

  if (loading) {
    return <div className="detailsPackContent">Loading...</div>;
  }

  if (error) {
    return (
      <div className="detailsPackOverlay">
        <div className="detailsPackModal">
          <div className="detailsPackContent">
            <div>{error}</div>
            <button onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    );
  }

  // Calculate progress and current period dates
  const { progress, currentStartDate, currentEndDate } = calculatePeriodAndProgress();

  return (
    <div className="souspackDetailsContent">
      <div className="souspackInfoContainer">

        {/* Date */}
        {isValidDate(currentStartDate) && isValidDate(currentEndDate) ? (
          <div className="detail-card detail-card--accent">
            <div className="detail-icon">
              <img src="images/packSXMG/date.jpg" alt="" className="detail-icon-img"
                onError={(e) => { e.target.style.display='none'; }}
              />
              {/* fallback si pas d'img */}
              <i className="ti ti-calendar" aria-hidden="true" />
            </div>
            <div className="detail-body">
              <span className="detail-label">Période active</span>
              <span className="detail-value">
                {currentStartDate.toLocaleDateString("fr-FR", { day:"2-digit", month:"2-digit", year:"numeric" })}
                {" — "}
                {currentEndDate.toLocaleDateString("fr-FR", { day:"2-digit", month:"2-digit", year:"numeric" })}
              </span>
            </div>
          </div>
        ) : (
          <p className="detail-empty">Aucune date de paiement disponible.</p>
        )}

        {/* Points */}
        <div className="detail-card">
          <div className="detail-icon">
            <img src="images/packSXMG/numberPoints.jpg" alt="" className="detail-icon-img" />
          </div>
          <div className="detail-body">
            <span className="detail-label">Number of points</span>
            <span className="detail-value">{details?.monthlyBonus?.points ?? "N/A"} Points</span>
          </div>
        </div>

        {/* Profit */}
        <div className="detail-card">
          <div className="detail-icon">
            <img src="images/packSXMG/profitAmount.jpg" alt="" className="detail-icon-img" />
          </div>
          <div className="detail-body">
            <span className="detail-label">Profit amount</span>
            <span className="detail-value">{formatPrice(details?.monthlyBonus?.value)} TND</span>
          </div>
        </div>

        {/* Progress */}
        <div className="detail-card detail-card--progress">
          <div className="detail-icon">
            <img src="images/packSXMG/pointsActivated.jpg" alt="" className="detail-icon-img" />
          </div>
          <div className="detail-body">
            <span className="detail-label">Points activated</span>
            <span className="detail-value">{Math.round(progress)}%</span>
            <div className="progress-bar">
              <div className="progress-bar-inner" style={{ width: `${progress}%` }} />
            </div>
          </div>
        </div>

        {/* Withdrawal */}
        <div className="detail-card">
          <div className="detail-icon">
            <img src="images/packSXMG/withdrawelPoints.jpg" alt="" className="detail-icon-img" />
          </div>
          <div className="detail-body">
            <span className="detail-label">Withdrawal of points</span>
            <span className="detail-value">{details?.withdrawalDays ?? "N/A"} Days</span>
          </div>
        </div>

      </div>
    </div>
  );
};


export default Popup_detailsPacks;